import React, { useEffect, useState } from "react";
import axios from "axios";
import UpdateSubject from "./UpdateSubject"; // Update form component
import { config } from "../../../config";

const apiUrl = config.apiUrl;

const ViewSubject = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingSubject, setEditingSubject] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  // Fetch subjects from API
  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get(`${apiUrl}/subjects`);
        setSubjects(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching subjects:", err);
        setLoading(false);
        setError("Failed to load subjects.");
      }
    };

    fetchSubjects();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Edit click
  const handleEditClick = (subject) => {
    setEditingSubject(subject.id);
    setFormData({
      name: subject.name,
      description: subject.description,
    });
  };

  // Handle Delete
  const handleDelete = async (subjectId) => {
    if (window.confirm("Are you sure you want to delete this subject?")) {
      try {
        await axios.delete(`${apiUrl}/subjects/${subjectId}`);
        alert("Subject deleted successfully");
        setSubjects((prev) => prev.filter((subj) => subj.id !== subjectId));
      } catch (err) {
        console.error("Error deleting subject:", err);
        setError("An error occurred while deleting the subject.");
      }
    }
  };

  // Handle Form Submit (Update)
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(`${apiUrl}/subjects/${editingSubject}`, formData);
      alert("Subject updated successfully");

      setSubjects((prev) =>
        prev.map((subj) =>
          subj.id === editingSubject ? { ...subj, ...formData } : subj
        )
      );

      setEditingSubject(null);
    } catch (err) {
      console.error("Error updating subject:", err);
      setError("An error occurred while updating the subject.");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Subjects</h2>
      {error && <p className="text-red-500">{error}</p>}

      {subjects.length === 0 ? (
        <p>No subjects found.</p>
      ) : (
        <table border="1" className="table-auto w-full text-left">
          <thead>
            <tr>
              <th className="border px-4 py-2">Subject Name</th>
              <th className="border px-4 py-2">Description</th>
              <th className="border px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {[...subjects].reverse().map((subject) => (
              <tr key={subject.id}>
                {!editingSubject || editingSubject !== subject.id ? (
                  <>
                    <td className="border px-4 py-2">{subject.name}</td>
                    <td className="border px-4 py-2">{subject.description}</td>
                    <td className="border px-4 py-2">
                      <button
                        onClick={() => handleEditClick(subject)}
                        className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(subject.id)}
                        className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                      >
                        Delete
                      </button>
                    </td>
                  </>
                ) : (
                  <td colSpan={3}>
                    <UpdateSubject
                      formData={formData}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                      error={error}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ViewSubject;
